import { useMutation } from "@tanstack/react-query";
import { get2 } from "../axios";
import useBranchId from "./useBranchId";
import { AppsmenError } from "../utils/interfaces";
import { errorToast } from "../utils/helpers";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  refundAmount?: string;
}

const useOrderRefund = () => {
  const branch = useBranchId();
  const { t } = useTranslation();

  const orderRefundMutation = useMutation<undefined, AppsmenError, Props>({
    mutationFn: ({ id }) =>
      get2(`internal/secure/pos/v1/orders/refund/${branch}/${id}`),
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: (error) => {
      if (error.response?.status === 503) {
        errorToast(error?.response?.data?.error_message);
      }
    },
  });

  const orderPartialRefundMutation = useMutation<
    undefined,
    AppsmenError,
    Props
  >({
    mutationFn: ({ id, refundAmount }) =>
      get2(
        `internal/secure/pos/v1/orders/refund/${branch}/${id}/${refundAmount}`
      ),
    onSuccess: () => {
      toast.success(t("success.success"));
    },
    onError: (error) => {
      if (error.response?.status === 503) {
        errorToast(error?.response?.data?.error_message);
      }
    },
  });

  return { orderRefundMutation, orderPartialRefundMutation };
};

export default useOrderRefund;
